module.exports = __webpack_public_path__ + "img/banner_download (2).fe14ddef.png";